import { createNamespacedDataProviderStore, extendStore } from './dataprovider';
import ApiClient from '../../client';
import { sortTaxonomyEntries } from '../../helpers/taxonomy-sort';

// Every pick-list in the payload. Sorted once here, at ingestion, so the profile form and the
// match filters render the same order without each consumer having to remember to sort.
const SORTED_LISTS = [
  'industries',
  'decisionLevels',
  'orgTypes',
  'budgetBrackets',
  'networkingGoals',
  'masterInterestTags',
  'eventInterestTags'
];

function withSortedLists(payload) {
  if (!payload) return payload;
  const out = { ...payload };
  SORTED_LISTS.forEach((key) => {
    if (Array.isArray(out[key])) {
      out[key] = sortTaxonomyEntries(out[key]);
    }
  });
  return out;
}

// Single-object resource (the full canonical taxonomies payload). Modelled as items[0]
// to ride on the helper's dedupe lock so multiple consumers on the same page (profile form,
// match filters, sponsor detail) only trigger one HTTP call.
const store = createNamespacedDataProviderStore((setItems) => {
  return ApiClient.getMatchingTaxonomies()
    .then((response) => {
      setItems([withSortedLists(response.data)]);
    })
    .catch(() => {
      setItems([]);
    });
});

const empty = {
  industries: [],
  decisionLevels: [],
  orgTypes: [],
  budgetBrackets: [],
  networkingGoals: [],
  masterInterestTags: [],
  eventInterestTags: []
};

export default extendStore(store, {
  getters: {
    getTaxonomies: (state) => state.items[0] || empty,
    industries: (state) => state.items[0]?.industries || [],
    decisionLevels: (state) => state.items[0]?.decisionLevels || [],
    orgTypes: (state) => state.items[0]?.orgTypes || [],
    budgetBrackets: (state) => state.items[0]?.budgetBrackets || [],
    networkingGoals: (state) => state.items[0]?.networkingGoals || [],
    eventInterestTags: (state) => state.items[0]?.eventInterestTags || []
  }
});
